import React, { useEffect } from 'react';
import { pushAnalytics } from '../../analytics/ym';

export function withViewAnalytics(WrappedComponent) {
  return (props) => {
    useEffect(() => {
      pushAnalytics('view');
    }, []);
    return <WrappedComponent {...props} />;
  };
}
